/* eslint-disable jsx-a11y/anchor-is-valid */
import Link from 'next/link'
import React from 'react'
//

const SITE_URL = process.env.NEXT_PUBLIC_SITE_URL || ''

export const NavLink = ({ to, children, trackingId, ...rest }) => {
  if (process.env.PREVIEW_MODE === 'true') {
    return (
      <a href="#" {...rest} onClick={(e) => e.preventDefault()}>
        {children}
      </a>
    )
  }

  if (!to) {
    return <div {...rest}>{children}</div>
  }

  let path = to

  const homepage = path === SITE_URL ? path : null

  path = to?.startsWith(SITE_URL) ? to?.replace(SITE_URL, '') : to

  if (path?.startsWith('/') || homepage) {
    return (
      <Link href={homepage ? '/' : path} {...rest} locale={false}>
        {children}
      </Link>
    )
  }

  const uriParts = path?.split('###')
  if (uriParts?.length > 1 && uriParts[uriParts?.length - 1]) {
    return <span id={uriParts[uriParts?.length - 1]}> </span>
  }

  const props = {}

  if ((!SITE_URL || !path?.startsWith(SITE_URL)) && !path?.startsWith('#')) {
    props.target = '_blank'
  }

  if (rest?.activeclassname) {
    props.className = props?.className
      ? `${props.className} ${rest.activeclassname}`
      : rest.activeclassname
    delete rest.activeclassname
  }

  return (
    <Link id={trackingId} href={path} {...props} {...rest}>
      {children}
    </Link>
  )
}

export default NavLink
